// @flow

import * as React from 'react';

import styles from './SectionModalHeader.less';

export type Props = {
  children: React.Node,
};

const SectionModalHeader = ({ children }: Props) => {
  const FULL_WIDTH_COLUMNS = 12;
  const FULL_WIDTH_OFFSET = 0;

  const RIGHT_SIDE_COLUMNS = 4;
  const RIGHT_SIDE_OFFSET = 8;

  const WIDE_SCREEN_COLUMNS = 3;
  const WIDE_SCREEN_OFFSET = 9;

  return (
    <div
      className={`ui_column
      is-${FULL_WIDTH_COLUMNS}-mobile is-offset-${FULL_WIDTH_OFFSET}-mobile
      is-${FULL_WIDTH_COLUMNS}-tablet is-offset-${FULL_WIDTH_OFFSET}-tablet
      is-${RIGHT_SIDE_COLUMNS}-desktop is-offset-${RIGHT_SIDE_OFFSET}-desktop
      is-${WIDE_SCREEN_COLUMNS}-widescreen is-offset-${WIDE_SCREEN_OFFSET}-widescreen
      ${styles.offset_header}`}
    >
      {children}
    </div>
  );
};

export default SectionModalHeader;
